import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-notification-destinations',
  templateUrl: './help-notification-destinations.component.html',
  styleUrls: ['./help-notification-destinations.component.scss']
})
export class HelpNotificationDestinationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
